import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import OutlinedInput from '@mui/material/OutlinedInput';
import { FormHelperText } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';


export const TextTypeInput = ({
    name,
    label,
    control,
    defaultValue,
    placeholder,
    children,
    errors,
    rules,
    height,
    width,
    inputType='text',
    inputAdornmentText,
    inputAdornment =false,
    multiLine=false,
    ...props
}) => {
    const labelId = `${name}-label`;
    return (

        <div className="flex flex-col gap-2 ">
            <FormControl >
                <label id={labelId}>{label}</label>
                <Controller
                    name={name}
                    control={control}
                    defaultValue={defaultValue}
                    rules={rules}
                    render={({ field }) => {
                        return (
                            <OutlinedInput
                                {...field}
                                type={inputType}
                                id="outlined-adornment-weight"
                                aria-describedby="outlined-weight-helper-text"
                                className='w-full rounded-3xl'
                                placeholder={placeholder}
                                style={{ 
                                    width: width, 
                                    ...(multiLine ? { minHeight: height,  overflow:'auto' } : { height: height }),
                                    borderRadius: '0.5rem', 
                                    alignItems: multiLine?'flex-start':'', 
                                    }}
                                onChange={(e) => {
                                    field.onChange(e.target.value) 
                                }}
                                startAdornment= {
                                   inputAdornment && <InputAdornment position="start" style={{padding:0,}}>
                                        {inputAdornmentText? inputAdornmentText: <> &#x20b9; </>}
                                    </InputAdornment>
                                }
                                disabled={ props.columnCheck}
                                multiline={multiLine}
                            />
                        )}}
                />
                {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
            </FormControl>
        </div>
    );
};
